import React, { useState, useEffect } from 'react'
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import * as Sentry from '@sentry/react'
import { getUser } from '../../../../services/oneUser'
import CookieManager from '../../../lib/CookiesManager'

interface UserServicesFormProps {
  formData: { title: string; description: string }
  handleFieldChange: (field: string, value: any) => void
}

const UserServicesForm: React.FC<UserServicesFormProps> = ({
  formData,
  handleFieldChange,
}) => {
  const { t } = useTranslation()
  const myProfile = localStorage.getItem('myProfile')
  const massageOnly = myProfile ? JSON.parse(myProfile).massageOnly : false

  const [selectedTab, setSelectedTab] = useState(
    massageOnly ? 'massage' : 'services',
  )
  const [status, setStatus] = useState<string[]>(() => {
    const localStorageData = localStorage.getItem('myAnnounce')
    const initialStatus = localStorageData
      ? JSON.parse(localStorageData).status || []
      : []
    if (massageOnly) {
      return [...initialStatus, 'massage']
    }

    return initialStatus
  })

  const options = [
    { id: 'private', description: t('create-ad.welcome-home') },
    { id: 'escort', description: t('create-ad.travel-client') },
    { id: 'massage', description: t('create-ad.massage-desc') },
  ]

  useEffect(() => {
    const fetchUserEmail = async () => {
      const userId = CookieManager.getUserId()
      const token = CookieManager.getToken()

      if (userId && token) {
        try {
          const userData = await getUser(userId, token)
          const userEmail = userData.user.email

          const myAnnounce = JSON.parse(
            localStorage.getItem('myAnnounce') || '{}',
          )
          myAnnounce.email = userEmail
          myAnnounce.userId = userId
          localStorage.setItem('myAnnounce', JSON.stringify(myAnnounce))
        } catch (error) {
          Sentry.captureException(error, {
            extra: {
              action: 'fetchUserEmail',
              userId,
              timestamp: new Date().toISOString(),
            },
            tags: {
              type: 'api_error',
              method: 'fetchUserEmail',
            },
          })
        }
      }
    }

    fetchUserEmail()
  }, [])

  const handleSelectionChange = (option: string) => {
    setStatus(prevStatus => {
      const updatedStatus = prevStatus.includes(option)
        ? prevStatus.filter(item => item !== option)
        : [...prevStatus, option]

      const localStorageData = getLocalStorageData()
      localStorageData.status = updatedStatus
      localStorage.setItem('myAnnounce', JSON.stringify(localStorageData))

      handleFieldChange('status', updatedStatus)

      return updatedStatus
    })
  }

  const getLocalStorageData = () => {
    const data = localStorage.getItem('myAnnounce')
    return data ? JSON.parse(data) : {}
  }

  return (
    <>
      {selectedTab === 'services' && (
        <>
          <div className='grid sm:mb-2 grid-cols-1 sm:grid-cols-3 gap-4'>
            {options.map(option => (
              <div
                key={option.id}
                className={`p-4 cursor-pointer text-center rounded-lg text-anthracite ${
                  status.includes(option.id)
                    ? 'bg-redpink text-white'
                    : 'bg-grisclair'
                }`}
                onClick={() => handleSelectionChange(option.id)}
              >
                <div className='flex items-center justify-center bg-anthracite mb-3 p-3 uppercase rounded-md'>
                  {status.includes(option.id) ? (
                    <MdCheckBox className='mr-3 text-xl' />
                  ) : (
                    <MdCheckBoxOutlineBlank className='mr-3 text-xl text-white' />
                  )}
                  <div>
                    <div className='block text-white'>
                      {t(`create-ad.${option.id}`)}
                    </div>
                  </div>
                </div>
                <div className='block'>{option.description}</div>
              </div>
            ))}
          </div>
        </>
      )}
      {selectedTab === 'massage' && (
        <>
          <div
            className={`w-full bg-grisclair  p-4 rounded-lg mb-4 uppercase font-bold transition-all text-anthracite flex items-center justify-center 
            }`}
          >
            {t('create-ad.massage-no-relation')}
          </div>
          <div className='grid grid-cols-2 gap-4 '>
            {options
              .filter(option => option.id !== 'massage')
              .map(option => (
                <div
                  key={option.id}
                  className={`p-4 transition-all cursor-pointer hover:bg-redpink text-center rounded-lg text-anthracite ${
                    status.includes(option.id)
                      ? 'bg-redpink text-white'
                      : 'bg-grisclair'
                  }`}
                  onClick={() => handleSelectionChange(option.id)}
                >
                  <div className=' transition-all flex items-center justify-center bg-anthracite mb-3 p-3 uppercase rounded-md'>
                    {status.includes(option.id) ? (
                      <MdCheckBox className='mr-3 text-xl' />
                    ) : (
                      <MdCheckBoxOutlineBlank className='mr-3 text-xl text-white' />
                    )}
                    <div>
                      <div className='block text-white transition-all'>
                        {selectedTab === 'massage' && option.id === 'private'
                          ? t('create-ad.welcome-you')
                          : ''}
                        {selectedTab === 'massage' && option.id === 'escort'
                          ? t('create-ad.travel-you')
                          : ''}
                      </div>
                    </div>
                  </div>
                  <div className='block'>{option.description}</div>
                </div>
              ))}
          </div>
        </>
      )}
    </>
  )
}

export default UserServicesForm
